type WorkbookSheet = {
  name: string;
  rows: Record<string, unknown>[];
};

type Workbook = {
  sheets: WorkbookSheet[];
};

const toArrayOfArrays = (rows: Record<string, unknown>[]) => {
  if (rows.length === 0) return [];

  const headers = Array.from(
    rows.reduce<Set<string>>((set, row) => {
      Object.keys(row || {}).forEach(key => set.add(key));
      return set;
    }, new Set<string>())
  );

  const values = rows.map(row => headers.map(header => (row as any)?.[header] ?? ''));

  return [headers, ...values];
};

const downloadCsv = (content: string, fileName: string) => {
  const normalizedName = fileName.endsWith('.csv') ? fileName : `${fileName}.csv`;
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = normalizedName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const utils = {
  json_to_sheet(rows: Record<string, unknown>[]) {
    return { rows };
  },
  book_new(): Workbook {
    return { sheets: [] };
  },
  book_append_sheet(workbook: Workbook, worksheet: { rows: Record<string, unknown>[] }, name: string) {
    workbook.sheets.push({ name, rows: worksheet.rows });
  },
};

export const writeFile = (workbook: Workbook, fileName: string) => {
  if (workbook.sheets.length <= 1) {
    const targetSheet = workbook.sheets[0];
    const csvRows = toArrayOfArrays(targetSheet?.rows ?? []);
    const csv = csvRows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')).join('\n');
    downloadCsv(csv, fileName);
    return;
  }

  // Multi-sheet: concatenate sheets separated by sheet name headers
  const sections = workbook.sheets.map(sheet => {
    const csvRows = toArrayOfArrays(sheet.rows);
    const header = `--- ${sheet.name} ---`;
    const body = csvRows.map(row => row.map(value => `"${String(value).replace(/"/g, '""')}"`).join(',')).join('\n');
    return `${header}\n${body}`;
  });
  downloadCsv(sections.join('\n\n'), fileName.replace(/\.xlsx$/, '.csv'));
};
